<!-- <nz-table #basicTable [nzBordered]="true" [nzData]="listOfData" [nzSize]="schema.size" [nzShowPagination]="true"
    [nzFrontPagination]="false" nzServerRender nzOuterBordered [nzPageSize]="_pageSize" [nzPageIndex]="_pageIndex"
    [nzLoading]="loading" [nzTotal]="total" (nzPageIndexChange)="onPageIndexChange($event)"
    [nzShowTotal]="totalTemplate" [nzScroll]="{ x: x_scrollWidth,y: tableHeight }" >  -->
<nz-table #basicTable [nzData]="listOfData" [nzLoading]="loading" [nzShowPagination]="true" [nzFrontPagination]="false"
    nzServerRender nzOuterBordered [nzPageSize]="_pageSize" [nzPageIndex]="_pageIndex" [nzTotal]="total"
    (nzPageIndexChange)="onPageIndexChange($event)" [nzShowTotal]="totalTemplate"
    [nzScroll]="{ x:x_scrollWidth,y: tableHeight }" style="margin-top: 50px;">

    <caption style="position: absolute; top: -40px;" class="custom-header">{{ schema.name }}</caption>

    <thead>
        <tr>
            <th *ngFor="let col of schema.columns;let i = index" [nzWidth]="col.width" [nzBreakWord]="true"
                [nzEllipsis]="true" [nzLeft]="col.isStickyLeft" [nzRight]="col.isStickyRight"
                [nzShowSort]="col.enableSort" [nzSortOrder]="col.enableSort ? sortMap[col.key] : null"
                (nzSortOrderChange)="onSort({ key: col.key, value: $event })">

                @if (col.key=='action' && schema.enableAdd) {
                <div class="header-content">
                    {{col.title}}
                </div>
                }
                @else {
                <div>
                    {{col.title}}
                </div>
                }
            </th>
        </tr>
        <tr>
            <th *ngFor="let col of schema.columns;let i = index" [nzWidth]="col.width" [nzBreakWord]="true"
                [nzEllipsis]="true" [nzLeft]="col.isStickyLeft" [nzRight]="col.isStickyRight">

                @if(col.enableSearch) {
                @if(col.searchType=='input'){
                <nz-input-group [nzSuffix]="inputClearTpl">
                    <input type="text" nz-input [(ngModel)]="filters[col.key]" (ngModelChange)="onFilterChange()"
                        (click)="$event.stopPropagation()" />
                </nz-input-group>
                <ng-template #inputClearTpl>
                    @if (filters[col.key]) {
                    <nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                        (click)="clearFilter(col.key)" />
                    }
                </ng-template>
                }
                @else if (col.searchType=='select') {
                <nz-select style="min-width: 100%;" nzPlaceHolder="Search {{col.title}}" nzAllowClear
                    [(ngModel)]="filters[col.key]" (ngModelChange)="onFilterChange()">
                    <nz-option *ngFor="let option of col.option" [nzLabel]="option.text"
                        [nzValue]="option.value"></nz-option>
                </nz-select>
                }
                @else if (col.searchType=='date') {
                <nz-date-picker [(ngModel)]="filters[col.key]" [nzFormat]="dateFormat" [nzAllowClear]="true"
                    (ngModelChange)="onDateChange($event,col.key)"></nz-date-picker>
                }
                @else if (col.searchType=='daterange') {
                <nz-range-picker [(ngModel)]="filters[col.key]" [nzFormat]="dateFormat" [nzAllowClear]="true"
                    (ngModelChange)="onDateRangeChange($event,col.key)"></nz-range-picker>
                }
                }
                @else if (col.key == 'action' && (canShowAddForHeader() || schema.enableDownload)) { <div
                    class="header-content" *ngIf="canShowAddForHeader() || schema.enableDownload">
                    <!-- <div style="padding-top: 0.5rem;"> -->
                    <button nz-tooltip *ngIf="canShowAddForHeader()" nz-button nzTooltipTitle="Create New" nzPrimary
                        (click)="onAdd()">
                        <nz-icon nzType="plus-circle" nzTheme="twotone" />
                    </button>
                    <button nz-tooltip *ngIf="schema.enableDownload" nz-button nzTooltipTitle="Download Excel" nzPrimary
                        (click)="onDownload()">
                        <nz-icon nzType="download" nzTheme="outline" />
                    </button>
                    <!-- </div> -->
                    </div>
                    }
                    @else{
                    <div class="header-content">

                    </div>
                    }
            </th>
        </tr>
        <!-- <tr>
            <th [nzEllipsis]="true" [nzBreakWord]="true" *ngFor="let col of schema.columns"
                [nzShowSort]="col.enableSort" [nzSortOrder]="col.enableSort ? sortMap[col.key] : null"
                (nzSortOrderChange)="onSort({ key: col.key, value: $event })"
                [nzRight]="col.key=='action' ? '0px' : null" [nzWidth]="col.width" [style.max-width]="col.width"
                [style.min-width]="col.width">
                @if(col.enableSearch) {
                <div class="header-content">
                    <div>{{col.title}}</div>
                    @if(col.searchType=='input'){
                    <nz-input-group [nzSuffix]="inputClearTpl">
                        <input type="text" nz-input [(ngModel)]="filters[col.key]" (ngModelChange)="onFilterChange()"
                            (click)="$event.stopPropagation()" />
                    </nz-input-group>
                    <ng-template #inputClearTpl>
                        @if (filters[col.key]) {
                        <nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
                            (click)="clearFilter(col.key)" />
                        }
                    </ng-template>
                    }
                    @else if (col.searchType=='select') {
                    <nz-select style="width: 50%;" nzPlaceHolder="Search {{col.title}}" nzAllowClear
                        [(ngModel)]="filters[col.key]" (ngModelChange)="onFilterChange()">
                        <nz-option *ngFor="let option of col.option" [nzLabel]="option.text"
                            [nzValue]="option.value"></nz-option>
                    </nz-select>
                    }
                    @else if (col.searchType=='date') {
                    <nz-date-picker [(ngModel)]="filters[col.key]" [nzFormat]="dateFormat" [nzAllowClear]="true"
                        (ngModelChange)="onDateChange($event,col.key)"></nz-date-picker>
                    }
                    @else if (col.searchType=='daterange') {
                    <nz-range-picker [(ngModel)]="filters[col.key]" [nzFormat]="dateFormat" [nzAllowClear]="true"
                        (ngModelChange)="onDateRangeChange($event,col.key)"></nz-range-picker>
                    }
                </div>
                }
                @else if (col.key=='action' && schema.enableAdd) {
                <div class="header-content">
                    <div style="padding-top: 0.5rem;">
                        <button nz-tooltip nz-button nzTooltipTitle="Create New" nzPrimary (click)="onAdd()">
                            <nz-icon nzType="plus-circle" nzTheme="outline" />
                        </button>
                    </div>
                </div>
                }
                @else{
                <div class="header-content">
                    <div> {{ col.title }}</div>
                </div>
                }
            </th>
        </tr> -->
    </thead>
    <tbody>
        <tr *ngFor="let data of listOfData;let i = index;">
            <td [nzEllipsis]="true" [nzBreakWord]="true" *ngFor="let col of schema.columns;let j=index;"
                [nzLeft]="col.isStickyLeft" [nzRight]="col.isStickyRight" [nzWidth]="col.width">
                <ng-container [ngSwitch]="col.type">
                    <!-- Text Columns -->
                    <span *ngSwitchCase="'autoGenerate'" class="number">{{ getSerialNo(i) }}</span>
                    <span *ngSwitchCase="'string'" class="text">
                        <ng-container *ngIf="col.key === 'content'; else normalText">
                            <div class="html-content" [innerHTML]="data[col.key]"></div>
                        </ng-container>

                        <ng-template #normalText>
                            {{ data[col.key] }}
                        </ng-template>
                    </span>

                    <span *ngSwitchCase="'rate'" class="text"><nz-rate class="custom-rate" [ngModel]="data[col.key]"
                            nzAllowHalf nzDisabled></nz-rate></span>
                    <span *ngSwitchCase="'image'">
                        @if(data[col.key].length>0) {
                        <img nz-image style="width: 75px;object-fit: contain;height: 100%;" [nzSrc]="data[col.key]"
                            alt="" />
                        }
                        @else{
                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256"
                            viewBox="0 0 256 256" xml:space="preserve">
                            <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                                transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                                <path
                                    d="M 89 20.938 c -0.553 0 -1 0.448 -1 1 v 46.125 c 0 2.422 -1.135 4.581 -2.898 5.983 L 62.328 50.71 c -0.37 -0.379 -0.973 -0.404 -1.372 -0.057 L 45.058 64.479 l -2.862 -2.942 c -0.385 -0.396 -1.019 -0.405 -1.414 -0.02 c -0.396 0.385 -0.405 1.019 -0.02 1.414 l 3.521 3.62 c 0.37 0.38 0.972 0.405 1.373 0.058 l 15.899 -13.826 l 21.783 22.32 c -0.918 0.391 -1.928 0.608 -2.987 0.608 H 24.7 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 55.651 c 5.32 0 9.648 -4.328 9.648 -9.647 V 21.938 C 90 21.386 89.553 20.938 89 20.938 z"
                                    style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                    transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                <path
                                    d="M 89.744 4.864 c -0.369 -0.411 -1.002 -0.444 -1.412 -0.077 l -8.363 7.502 H 9.648 C 4.328 12.29 0 16.618 0 21.938 v 46.125 c 0 4.528 3.141 8.328 7.356 9.361 l -7.024 6.3 c -0.411 0.368 -0.445 1.001 -0.077 1.412 c 0.198 0.22 0.471 0.332 0.745 0.332 c 0.238 0 0.476 -0.084 0.667 -0.256 l 88 -78.935 C 90.079 5.908 90.113 5.275 89.744 4.864 z M 9.648 14.29 h 68.091 L 34.215 53.33 L 23.428 42.239 c -0.374 -0.385 -0.985 -0.404 -1.385 -0.046 L 2 60.201 V 21.938 C 2 17.721 5.431 14.29 9.648 14.29 z M 2 68.063 v -5.172 l 20.665 -18.568 l 10.061 10.345 L 9.286 75.692 C 5.238 75.501 2 72.157 2 68.063 z"
                                    style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                    transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                                <path
                                    d="M 32.607 35.608 c -4.044 0 -7.335 -3.291 -7.335 -7.335 s 3.291 -7.335 7.335 -7.335 s 7.335 3.291 7.335 7.335 S 36.652 35.608 32.607 35.608 z M 32.607 22.938 c -2.942 0 -5.335 2.393 -5.335 5.335 s 2.393 5.335 5.335 5.335 s 5.335 -2.393 5.335 -5.335 S 35.549 22.938 32.607 22.938 z"
                                    style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
                                    transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                            </g>
                        </svg>
                        }
                    </span>
                    <span *ngSwitchCase="'tag'" class="text-tag">
                        <nz-tag [nzColor]="getTagColor(data[col.key])">{{ data[col.key] | capitalLetter }}</nz-tag>
                    </span>
                    <span *ngSwitchCase="'string_arr'" class="text-tag">
                        <nz-tag *ngFor="let val of data[col.key];let k=index;">{{ val }}</nz-tag>
                    </span>


                    <span *ngSwitchCase="'number'" class="number">{{ data[col.key] }}</span>
                    <span *ngSwitchCase="'date'" class="text">{{ data[col.key] | date: 'dd-MM-yyyy HH:mm'}}</span>
                    <span *ngSwitchCase="'dateOnly'" class="text">{{ data[col.key] | date: 'dd-MM-yyyy'}}</span>
                    <span *ngSwitchCase="'object'" class="text">{{ getCellValue(data,col.key)}}</span>
                    <ng-container *ngSwitchCase="'status'">
                        <span class="text-status">
                            <nz-icon nzType="minus-square" *ngIf="data[col.key]==1" nzTheme="twotone" />
                            <nz-icon nzType="up-circle" *ngIf="data[col.key]==2" nzType="up-circle" nzTheme="twotone"
                                [nzTwotoneColor]="'#52c41a'" />
                            <nz-icon *ngIf="data[col.key]==3" nzType="down-circle" nzTheme="twotone"
                                [nzTwotoneColor]="'#ff4d4f'" />
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'trophy'">
                        <span class="text-trophy">
                            <nz-icon nzType="trophy" *ngIf="data[col.key]==true" nzTheme="twotone" />
                            <nz-icon nzType="close-square" *ngIf="!data[col.key]" nzType="close-square"
                                nzTheme="twotone" [nzTwotoneColor]="'#ff4d4f'" />
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'chart'">
                        <g2-mini-area line color="#cceafe" height="45" [data]="data[col.key]" />
                    </ng-container>
                    <ng-container *ngFor="let label of col.label">
                        <button nz-button [nzType]="label.type"
                            (click)="label.type === 'edit' ? onEdit(data) : label.type === 'gen' ? onGenerateResult(data) : onDelete(data)"
                            *ngIf="canShowLabel(label)" [nzDanger]="label.isDanger">
                            <ng-container [ngSwitch]="label.type">
                                <!-- Edit button -->
                                <nz-icon *ngSwitchCase="'edit'" nz-tooltip nzTooltipTitle="Edit" nzType="edit"
                                    nzTheme="twotone"></nz-icon>

                                <!-- Generate Quiz Result button -->
                                <nz-icon *ngSwitchCase="'gen'" nz-tooltip nzTooltipTitle="Generate Quiz Result"
                                    nzType="trophy" nzTheme="twotone"></nz-icon>

                                <!-- Delete button -->
                                <nz-icon *ngSwitchCase="'danger'" nz-tooltip nzTooltipTitle="Delete" nzType="delete"
                                    [nzTwotoneColor]="'#ff4d4f'" nzTheme="twotone"></nz-icon>
                            </ng-container>
                        </button>
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </tbody>
</nz-table>
<ng-template #totalTemplate let-range="range" let-total>
    Showing {{ range[0] }} - {{ range[1] }} of {{ total }} items
</ng-template>